<div class="calculations-list-container">
  <div class="list-header" *ngIf="showCreateButton">
    <h2>{{ myCalculationsText }}</h2>
    <button 
      (click)="onCreate()" 
      class="btn btn-primary"
      type="button"
    >
      {{ createCalculationText }}
    </button>
  </div>

  <!-- Filters -->
  <div class="filters-section">
    <div class="filters-row">
      <div class="filter-group">
        <label>{{ dateFromText }}:</label>
        <input 
          type="date" 
          [(ngModel)]="dateFrom" 
          class="filter-input"
        />
      </div>
      
      <div class="filter-group">
        <label>{{ dateToText }}:</label>
        <input 
          type="date" 
          [(ngModel)]="dateTo" 
          class="filter-input"
        />
      </div>

      <div class="filter-group">
        <label>{{ titleFilterText }}:</label>
        <input 
          type="text" 
          [(ngModel)]="title" 
          class="filter-input"
          [placeholder]="titleFilterText"
        />
      </div>
      
      <button 
        (click)="applyFilters()" 
        class="btn btn-primary btn-sm"
        type="button"
      >
        {{ applyFiltersText }}
      </button>
      
      <button 
        (click)="clearFilters()" 
        class="btn btn-secondary btn-sm"
        type="button"
        [disabled]="!hasActiveFilters()"
      >
        {{ clearFiltersText }}
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="loading-message">
    {{ loadingText }}
  </div>

  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>

  <div *ngIf="!loading && !error && calculations.length === 0" class="empty-state">
    <p>{{ noCalculationsText }}</p>
    <button 
      *ngIf="showCreateButton"
      (click)="onCreate()" 
      class="btn btn-primary"
      type="button"
    >
      {{ createCalculationText }}
    </button>
  </div>

  <div *ngIf="!loading && !error && calculations.length > 0" class="calculations-table-container">
    <table class="calculations-table">
      <thead>
        <tr>
          <th>{{ calculationTitleText }}</th>
          <th *ngIf="showOwnerColumn">{{ ownerColumnText }}</th>
          <th>{{ productsCountText }}</th>
          <th>{{ createdAtText }}</th>
          <th>{{ totalAmountText }}</th>
          <th>{{ statusText }}</th>
          <th>{{ actionsText }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let calculation of calculations">
          <td>
            {{ calculation.title || (calculationFallbackPrefixText + calculation.id) }}
          </td>
          <td *ngIf="showOwnerColumn">{{ calculation.ownerDisplayName || '-' }}</td>
          <td>{{ getProductsCount(calculation) }}</td>
          <td>{{ calculation.createdAt | date:'dd.MM.yyyy HH:mm' }}</td>
          <td class="total-amount">
            {{ getTotalAmount(calculation) > 0 ? (getTotalAmount(calculation) | number:'1.2-2') + ' ₸' : '-' }}
          </td>
          <td>
            <span class="status-badge status-{{ (calculation.status || 'created') | lowercase }}">
              {{ statusLabel(calculation.status) }}
            </span>
            <span *ngIf="calculation.completedWithAi" class="ai-badge">
              {{ completedWithAiText }}
            </span>
          </td>
          <td>
            <div class="actions-cell">
              <button 
                (click)="onView(calculation.id)"
                class="btn btn-secondary btn-sm"
                type="button"
              >
                {{ viewText }}
              </button>
              <button 
                *ngIf="showDeleteButton"
                (click)="onDelete(calculation.id, $event)"
                class="btn btn-danger btn-sm"
                type="button"
                [title]="deleteText"
              >
                {{ deleteText }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <app-pagination
      *ngIf="calculationsPage"
      [number]="calculationsPage.number"
      [totalPages]="calculationsPage.totalPages"
      [size]="calculationsPage.size"
      [totalElements]="calculationsPage.totalElements"
      [hasNext]="calculationsPage.hasNext"
      [hasPrevious]="calculationsPage.hasPrevious"
      (pageChange)="onPageChange($event)"
    ></app-pagination>
  </div>
</div>
